(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
     



  //Added by 3node dev Kamil on Sept. 13th 2023
  document.getElementById("icoToggleCheckbox").onclick = function cartIcoToggle(){
    var div = document.getElementById("hide-ico-dic");
    if (this.checked) div.style.display = "block";
    else div.style.display = "none";
    return;
  }
  



  } catch(e) { console.error(e); }
})();
})();
